import { RangeValue } from "@evergis/ui";
import {
  isCompositeLayerConfiguration,
  isProxyService,
  LayerInfo,
  LayerType,
  ProxyServiceInfo,
} from "../../../interfaces/resourceInfo";

import { getLayerDefinition } from "./getLayerDefinition";
import { getLayerStyleProxy } from "./getLayerStyle";
import { getServiceConfiguration } from "./getServiceConfiguration";
import { getAttributesConfiguration } from "./getAttributesConfiguration";

export const getProxyService = (layer?: LayerType): ProxyServiceInfo => {
  if (!isProxyService(layer))
    return {
      layers: [],
      sourceType: "",
      sourceUrl: "",
      copyrightText: "",
      legend: {
        layers: [],
      },
    };

  const { layers, sourceType, sourceUrl, legend, copyrightText } = layer;

  return {
    layers: layers || [],
    copyrightText: copyrightText || "",
    sourceUrl: sourceUrl || "",
    sourceType: sourceType || "",
    legend: {
      layers: (legend && legend.layers) || [],
    },
  };
};

export function getLayerInfo(layer?: LayerType & { type?: string }, defaultScaleRange?: RangeValue): LayerInfo {
  const configuration = getServiceConfiguration(layer);
  const attributesConfiguration = getAttributesConfiguration(layer);
  const layerDefinition = getLayerDefinition(layer as LayerInfo);
  const style = getLayerStyleProxy(layer, defaultScaleRange);
  const configLayers = ("layers" in configuration && configuration.layers) || [];

  return {
    type: layer?.type,
    ...(layer || {}),
    name: layer?.name || "",
    configuration: {
      ...configuration,
      layers: (configLayers as string[]).filter(isCompositeLayerConfiguration),
      attributesConfiguration,
    },
    acl: configuration.acl,
    condition: ("condition" in configuration && configuration.condition) || undefined,
    tableName: attributesConfiguration.tableName,
    idAttribute: attributesConfiguration.idAttribute,
    titleAttribute: layerDefinition.titleAttribute || attributesConfiguration.titleAttribute,
    geometryAttribute: attributesConfiguration.geometryAttribute,
    layerAttributes: attributesConfiguration.attributes,
    style,
    sr: layerDefinition.spatialReference,
    proxy: getProxyService(layer),
  } as LayerInfo;
}
